<template>
    <div @click="$emit('switch-thread', thread.id); handleThread();"
         class="chat-item--wrapper"
         :style="active ? styleSelected : styleNormal ">
        <avartar
                :name="thread.name"
                :size="size"
                class="chat-item--avartar">
            <div v-if="thread.online" class="chat-item--status"></div>
        </avartar>
        <div class="chat-item-content">
            <div class="chat-item--title">
                <div class="chat-item--name"> {{ thread.name }} </div>
                <div class="chat-item--time"> {{ time }} </div>
            </div>
            <div v-if="!thread.incomming || active"
                 class="chat-item--subtitle">
                <span>{{ text }}</span>
                <div v-if="thread.unreadCount > 0" class="chat-item--unread">
                    {{ thread.unreadCount }}
                </div>
            </div>
            <div v-else class="chat-item--subtitle">
                <dot-loader size="4px"></dot-loader>
            </div>
        </div>
    </div>
</template>

<script>
import Avartar from './Avartar'
import DotLoader from './DotLoader'
import * as dateUtils from '../utils/timeutils'

export default {
  name: 'ChatItem',
  props: {
    thread: Object,
    active: Boolean,
    size: Number
  },
  components: {
    Avartar,
    DotLoader
  },
  methods: {
      handleThread: function () {
          this.$store.commit('threadSwitch', true)
      }
  },
  computed: {
    time: function () {
      let result = ''
      if (this.thread.lastMessage) {
        const isChinese = this.$store.getters.isChineseText
        const lastTime = this.thread.lastMessage.time
        const isToday = dateUtils.isToday(lastTime)
        result = isToday ?  dateUtils.formatHourMinutes(lastTime, isChinese) : dateUtils.formatDate(lastTime)
      }
      return result
    },
    text: function () {
      const content = this.thread.lastMessage ? this.thread.lastMessage.content : ''
      return content.length > 20 ?  content.substring(0, 20) + '...' : content
    },
    showIncomming: function () {
      return
    }
  },
  data () {
    return {
      styleSelected: {
        'background-color': 'lightgray'
      },
      styleNormal: {

      }
    }
  }
}
</script>

<style lang="scss">
.chat-item--wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-top: 8px;
    padding-bottom: 8px;
    .chat-item--avartar {
        margin-left: 5px;
        position: relative;
        flex-shrink: 0;
        .chat-item--status {
            width: 8px;
            height: 8px;
            border-radius: 4px;
            background-color: green;
            position: absolute;
            bottom: 0;
            right: 4px;
        }
    }
    .chat-item-content {
        margin-left: 4px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: 14px;
        flex-grow: 1;
        .chat-item--title {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .chat-item--name {
                font-weight: bold;
            }
            .chat-item--time {
                font-size: 12px;
                margin-right: 12px;
            }
        }
        .chat-item--subtitle {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .chat-item--unread {
                margin-right: 12px;
                width: 16px;
                height: 16px;
                border-radius: 8px;
                background-color: #db4437;
                font-size: 12px;
            }
        }
    }
}
.chat-item--wrapper:hover {
    background-color: lightblue;
}
</style>
